module.exports = __webpack_public_path__ + "img/icon-crown.789be657.svg";